'use client';

import { useEffect } from 'react';
import { useTheme } from 'next-themes';

import {
  resolveCatalogBrowserChrome,
  type CatalogThemeMode,
} from '@/lib/store-theme';

function setMetaContent(name: string, content: string) {
  let meta = document.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', name);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
}

function syncThemeColorMeta(content: string) {
  const metas = document.querySelectorAll('meta[name="theme-color"]');
  if (metas.length === 0) {
    setMetaContent('theme-color', content);
    return;
  }

  // Update in place — never remove nodes Next.js may reconcile on client navigations.
  metas.forEach((meta) => {
    meta.setAttribute('content', content);
    meta.removeAttribute('media');
  });
}

/**
 * Keeps mobile browser chrome (Safari status bar, Android theme-color) aligned
 * with the store catalog theme mode and the shopper's resolved light/dark choice.
 */
export function CatalogBrowserChromeSync({ mode }: { mode: CatalogThemeMode }) {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    const chrome = resolveCatalogBrowserChrome(mode, resolvedTheme);

    syncThemeColorMeta(chrome.themeColor);
    setMetaContent('apple-mobile-web-app-status-bar-style', chrome.appleStatusBarStyle);
    document.documentElement.style.colorScheme = chrome.colorScheme;
  }, [mode, resolvedTheme]);

  return null;
}
